export const cents = (v) => (v == null ? "—" : `${(v * 100).toFixed(v * 100 < 10 ? 1 : 0)}¢`);
export const pct = (v) => (v == null ? "—" : `${Math.round(v * 100)}%`);

export const endsIn = (m) => {
  const iso = m.group === "sports" && m.game_start && new Date(m.game_start) > new Date() ? m.game_start : m.end_date;
  if (!iso) return "—";
  const s = (new Date(iso) - Date.now()) / 1000;
  if (s <= 0) return "closing";
  if (s < 3600) return `${Math.round(s / 60)}m`;
  if (s < 86400 * 2) return `${Math.round(s / 3600)}h`;
  return `${Math.round(s / 86400)}d`;
};

export const CATS = [
  ["all", "All"], ["sports", "Sports"], ["politics", "Politics"], ["crypto", "Crypto"],
  ["culture", "Culture"], ["finance", "Finance"], ["tech", "Tech & Science"],
];

export const paperChanged = () => window.dispatchEvent(new Event("paper-changed"));
